import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { 
  ChevronDownIcon,
  ChevronRightIcon
} from '@heroicons/react/24/outline';
import './CategoryNavigation.css';
import { Category } from '../features/categories/categoryModels';


interface CategoryNavigationProps {
  categories: Category[];
  onCategorySelect: (categoryId: string) => void;
  isOpen: boolean;
  onToggle: () => void;
}

const CategoryNavigation: React.FC<CategoryNavigationProps> = ({
  categories,
  onCategorySelect,
  isOpen,
  onToggle
}) => {
  const { t } = useTranslation();
  const [expandedCategories, setExpandedCategories] = useState<Set<string>>(new Set());
  const sortedCategories = [...categories].sort((a, b) => a?.categoryOrder - b?.categoryOrder);

  const toggleCategory = (categoryId: string) => {
    setExpandedCategories(prev => {
      const newSet = new Set(prev);
      if (newSet.has(categoryId)) {
        newSet.delete(categoryId);
      } else {
        newSet.add(categoryId);
      }
      return newSet;
    });
    // navigate to category page
    
  };

  const handleCategoryClick = (category: Category) => {
    onCategorySelect(category._id);
    onToggle();
  };

  const renderCategory = (category: Category, level: number = 0) => {
    // const hasSubcategories = category.subcategories && category.subcategories.length > 0;
    const isExpanded = expandedCategories.has(category._id);

    return (
      <div key={category._id} className={`category-item level-${level}`}>
        <div className="category-row">
          <Link 
              key={category._id} 
              to={`/products?category=${category._id}`} 
              onClick={() => handleCategoryClick(category)}
              className={"category-button"}>
                        
  
            <div className="category-content">
              <img className="category-icon" src={category.imagePath} alt={category.categoryName} />
              <span className="category-name">{category.categoryName}</span>
              <span className="category-count">({category.productCount})</span>
            </div>
            {/* {hasSubcategories && (
              <div className="category-arrow">
                {isExpanded ? (
                  <ChevronDownIcon className="arrow-icon" />
                ) : (
                  <ChevronRightIcon className="arrow-icon" />
                )}
              </div>
            )} */}
          </Link>
        </div>

        {/* {hasSubcategories && isExpanded && (
          <div className="subcategories">
            {category.subcategories!.map(subcategory => 
              renderCategory(subcategory, level + 1)
            )}
          </div>
        )} */}
      </div>
    );
  };

  return (
    <div className={`category-navigation ${isOpen ? 'open' : ''}`}>
      <div className="category-header">
        <h3>{t('categories.allCategories')}</h3>
        <button 
          className="close-categories-button"
          onClick={onToggle}
        >
          ×
        </button>
      </div>

      <div className="category-content">
        <div className="category-list">
          {sortedCategories.map(category => renderCategory(category))}
        </div>

        <div className="category-footer">
          <Link 
            to="/categories" 
            className="view-all-categories"
            onClick={onToggle}
          >
            {t('categories.viewAllCategories')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CategoryNavigation;
